import _ from 'lodash'

/**
 * @deprecated
 */
export default class BearerToken {
  static getId () {
    return _.get(this.storage(), '_id')
  }

  static getToken () {
    return _.get(this.storage(), 'token')
  }

  static store (data) {
    _.forIn(_.pick(data, ['_id', 'token']), (value, name) => {
      this.storage()[name] = value
    })
  }

  static storage () {
    return window.localStorage
  }

  static destroy () {
    delete this.storage()._id
    delete this.storage().token
  }
}
